import { ForwardRefExoticComponent, RefAttributes } from "react";
import { ProductReferenceResponseWithType } from "../../../../../api/models/ProductReferenceResponse";
import CompetitorProduct from "../../../../../api/models/product/CompetitorProduct";
import CustomSearchAutoComplete, {
  CustomSearchAutocompleteProps,
} from "../../../../../components/Autocomplete/CustomSearchAutoComplete";

export const CompetitorProductAutocomplete = CustomSearchAutoComplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<CompetitorProduct> & RefAttributes<{ reset: () => void }>
>;

export interface CompetitorSampleAddFormType {
  product: CompetitorProduct | null;
}

export interface CompetitorSampleAddFormProps {
  preset?: ProductReferenceResponseWithType | null;
  hideSubmit?: boolean;
  handleFormChange?: (values: CompetitorSampleAddFormType) => void;
  handleSubmit?: (values: CompetitorSampleAddFormType) => void;
  disabled?: boolean;
  suggestion?: string;
  notFoundLink?: boolean;
}
